import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";

import Loading from "../../Layouts/Loading";

import Toast from "../../Components/Toast";
import Navbar from "../../Layouts/Navbar";

import Header from "../../Layouts/Header";
import {useNavigate, useParams} from "react-router-dom";

import {BiCategoryAlt} from "react-icons/bi";


export default function ScoreDetails() {
    const {id} = useParams();
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [scores, setScores] = React.useState([]);


    React.useEffect(() => {

        API.getScoreDetails(id)
            .then((response) => {
                setScores(response.data)
                setIsLoaded(true);
            })
            .catch((error) => {
                setIsLoaded(true);
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, []);



    return (
        <React.Fragment>
            <Toast />
            <Header title='امتیازهای دریافتی' hasBack={true}/>
            {
                !isLoaded && <Loading/>
            }


            <section className="container-fluid mt-3 rtl pb-5 ">
                <div className="row">
                    <div className="col-12 home-separator-text ">
                        <BiCategoryAlt className='mx-2'/>
                       امتیاز دریافتی از شرکت ها
                    </div>
                </div>
                {
                    isLoaded && scores.map (score => {
                        return (
                            <div className="row score-row m-3 p-3" key={score.id}>
                                <div className="col-2 p-1">
                                    <img src={score.image} alt={score.name}
                                         onClick={() => {
                                             navigate(`/vendor/${id}/${score.id}`)
                                         }
                                         }

                                         className='w-100'
                                    />

                                </div>
                                <div className="col-7 text-small-1 fw-bold pt-4">
                                    {
                                        score.name
                                    }

                                </div>
                                <div className="col-3 fw-bold text-start text-small-1 text-primary-color pt-4">
                                    {
                                        score.score
                                    }
                                    &nbsp;
                                    امتیاز
                                </div>
                            </div>
                        )
                    })
                }

            </section>
            <Navbar />
        </React.Fragment>

    );
}

